(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (window.nexpepRelatedCardsReady) return;
  window.nexpepRelatedCardsReady = true;
  const themeEvents = import('@theme/events').catch(() => null);
  const busy = new WeakSet();
  const titles = new Set();
  const widths = new WeakMap();
  const regions = new Map();
  let scheduled = false;
  const fitTitle = title => {
    if (!title.isConnected || !title.clientWidth) return;
    const label = title.querySelector('a');
    if (!label) return;
    title.style.fontSize = '';
    const base = parseFloat(getComputedStyle(title).fontSize);
    if (label.scrollWidth > title.clientWidth) {
      title.style.fontSize = Math.max(12, base * (title.clientWidth - 1) / label.scrollWidth).toFixed(2) + 'px';
    }
  };
  const resize = new ResizeObserver(entries => {
    for (const entry of entries) {
      if (widths.get(entry.target) !== entry.contentRect.width) {
        widths.set(entry.target, entry.contentRect.width);
        fitTitle(entry.target);
      }
    }
  });
  const updateVisibility = () => {
    let visible = false;
    for (const [region, value] of regions) {
      if (!region.isConnected) {
        visibility.unobserve(region);
        regions.delete(region);
      } else if (value) visible = true;
    }
    document.body.classList.toggle('np-related-visible', visible);
  };
  const visibility = new IntersectionObserver(entries => {
    entries.forEach(entry => regions.set(entry.target, entry.isIntersecting));
    updateVisibility();
  });
  const init = () => {
    scheduled = false;
    for (const title of titles) {
      if (!title.isConnected) { resize.unobserve(title); titles.delete(title); }
    }
    document.querySelectorAll('.np-related [data-npr-card]').forEach(card => {
      if (!busy.has(card.querySelector('[data-npr-form]'))) {
        card.querySelectorAll('[data-npr-variant-button]').forEach(button => { button.disabled = false; });
      }
      const title = card.querySelector('[data-npr-title]');
      if (title && !titles.has(title)) { titles.add(title); resize.observe(title); fitTitle(title); }
    });
    document.querySelectorAll('.np-related__inner').forEach(region => {
      if (!regions.has(region)) { regions.set(region, false); visibility.observe(region); }
    });
    updateVisibility();
  };
  const schedule = () => { if (!scheduled) { scheduled = true; requestAnimationFrame(init); } };
  const observer = new MutationObserver(mutations => {
    if (mutations.some(mutation => mutation.target.closest?.('.np-related') || [...mutation.addedNodes, ...mutation.removedNodes].some(node =>
      node.nodeType === 1 && (node.matches('.np-related,.np-related__inner,[data-npr-card]') || node.querySelector('.np-related,.np-related__inner,[data-npr-card]'))
    ))) schedule();
  });
  observer.observe(document.body, {childList:true,subtree:true});
  document.addEventListener('shopify:section:load', schedule);
  document.addEventListener('shopify:section:unload', schedule);
  window.addEventListener('pageshow', schedule);
  if (document.fonts) document.fonts.ready.then(() => titles.forEach(fitTitle));
  document.addEventListener('click', event => {
    const button = event.target.closest('.np-related [data-npr-variant-button]');
    if (!button || button.disabled) return;
    const card = button.closest('[data-npr-card]');
    const form = card.querySelector('[data-npr-form]');
    if (busy.has(form)) return;
    const data = button.dataset;
    card.querySelector('[data-npr-variant-id]').value = data.variantId;
    card.querySelectorAll('[data-npr-variant-button]').forEach(option => option.setAttribute('aria-pressed', String(option === button)));
    card.querySelector('[data-npr-price]').textContent = data.price;
    const compare = card.querySelector('[data-npr-compare]');
    compare.textContent = data.compare;
    compare.hidden = !data.compare;
    const stock = card.querySelector('[data-npr-stock]');
    stock.dataset.available = data.available;
    stock.dataset.preorder = data.preorder;
    card.querySelector('[data-npr-stock-text]').textContent = data.stock.split(' · ').join('\n');
    const add = card.querySelector('[data-npr-add]');
    add.disabled = data.available !== 'true';
    add.textContent = add.disabled ? 'Sold out' : data.preorder === 'true' ? 'Pre-order' : 'Add to cart';
    card.querySelectorAll('[data-npr-product-link]').forEach(link => { link.href = data.url; });
    const image = card.querySelector('.np-related__image');
    if (image && data.image) { image.removeAttribute('srcset'); image.src = data.image; image.alt = data.imageAlt; }
    const feedback = card.querySelector('[data-npr-feedback]');
    feedback.replaceChildren();
    delete feedback.dataset.error;
  });
  document.addEventListener('submit', async event => {
    const form = event.target.closest('.np-related [data-npr-form]');
    if (!form) return;
    event.preventDefault();
    const card = form.closest('[data-npr-card]');
    const add = card.querySelector('[data-npr-add]');
    if (busy.has(form) || add.disabled) return;
    busy.add(form);
    const label = add.textContent;
    const body = new FormData(form);
    const selectedId = body.get('id');
    const sectionIds = [...document.querySelectorAll('cart-items-component[data-section-id]')].map(item => item.dataset.sectionId);
    if (sectionIds.length) body.set('sections', [...new Set(sectionIds)].join(','));
    body.set('sections_url', location.pathname);
    const endpoint = new URL(form.action);
    endpoint.pathname = endpoint.pathname.replace(/\/$/, '') + '.js';
    const cartUrl = new URL(form.action);
    cartUrl.pathname = cartUrl.pathname.replace(/\/add\/?$/, '');
    const feedback = card.querySelector('[data-npr-feedback]');
    feedback.textContent = 'Adding to cart…';
    delete feedback.dataset.error;
    form.setAttribute('aria-busy', 'true');
    add.disabled = true;
    add.textContent = 'Adding…';
    card.querySelectorAll('[data-npr-variant-button]').forEach(button => { button.disabled = true; });
    let added = false;
    const updateCart = async (result, didError = false) => {
      try {
        const cartResponse = await fetch(cartUrl.toString() + '.js', {headers:{Accept:'application/json'}});
        const cart = cartResponse.ok ? await cartResponse.json() : undefined;
        const events = await themeEvents;
        if (events) form.dispatchEvent(new events.CartAddEvent(cart, String(selectedId), {
          source:'np-related',itemCount:1,productId:card.dataset.nprProductId,sections:result.sections,didError
        }));
      } catch (_) {}
    };
    try {
      const response = await fetch(endpoint, {method:'POST',body,headers:{Accept:'application/json'}});
      const result = await response.json();
      if (!response.ok || result.status) {
        feedback.dataset.error = 'true';
        feedback.textContent = typeof result.description === 'string' ? result.description : 'This item could not be added. Check its details and try again.';
        await updateCart(result, true);
        return;
      }
      added = true;
      add.textContent = 'Added';
      feedback.textContent = 'Added to cart. ';
      const viewCart = document.createElement('a');
      viewCart.href = cartUrl.toString();
      viewCart.textContent = 'View cart';
      feedback.append(viewCart);
      await updateCart(result);
    } catch (_) {
      feedback.dataset.error = 'true';
      feedback.textContent = 'We could not confirm the addition. Check your cart before trying again. ';
      const viewCart = document.createElement('a');
      viewCart.href = cartUrl.toString();
      viewCart.textContent = 'View cart';
      feedback.append(viewCart);
    } finally {
      const unlock = () => {
        busy.delete(form);
        form.removeAttribute('aria-busy');
        add.disabled = false;
        add.textContent = label;
        card.querySelectorAll('[data-npr-variant-button]').forEach(button => { button.disabled = false; });
      };
      if (added) setTimeout(unlock, 1000); else unlock();
    }
  });
  init();
})();


  } catch(e) { console.error(e); }
})();
})();
